module.exports = __webpack_public_path__ + "img/about_bg.31e80192.jpg";